"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lauro": {
    "1537ec5c": [{
      "hkey": "5cff1978",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "fontenovella": [{
      "hkey": "5cff1978",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lauro"
    }],
    "0a82e48f": [{
      "hkey": "5cff1978",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ima": [{
      "hkey": "5cff1978",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lauro"
    }],
    "255b5326": [{
      "hkey": "5cff1978",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "5cff1978",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5184d56c": [{
      "hkey": "fb9de784",
      "slug": "lauro",
      "name": "Lauro",
      "primary": true,
      "skipSearch": false
    }],
    "preturo": [{
      "hkey": "fb9de784",
      "slug": "lauro",
      "name": "Lauro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "32c32e59": [{
      "hkey": "fb9de784",
      "slug": "lauro",
      "name": "Lauro",
      "primary": true,
      "skipSearch": false
    }],
    "vigna": [{
      "hkey": "fb9de784",
      "slug": "lauro",
      "name": "Lauro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;